<template lang="pug">
    ib-col(class="flex resultsview")
        ib-row(v-if="resultsview")
            ib-col(class="insety-8 insetx-16")
                h3(v-if="cusip && cusip !=''") {{ $t('search_by_cusip') }}
                h3(v-else) {{ curTabName }}
                div(v-if="cusip && cusip !=''" class="fs7 fg50 before-8 mobile-desr")
                    span(class="bndInfo") {{ $t('CUSIP') }}:
                    span(class="fg-accent" @click="showTabs") {{ cusip }}
                    span &nbsp;
                div(v-else, class="fs7 fg50 before-8 mobile-desr")
                    span(v-if="bondFields.startDate && !bondFields.endDate")
                        span(class="fg-accent grab bndInfo" @click="showTabs") {{ bondFields.startDate | formatDate }}
                        span(class="bndInfo") {{ $t('to') }}
                        span(class="fg-accent") ...
                        span &nbsp;
                    span(v-else-if="!bondFields.startDate && bondFields.endDate")
                        span(class="fg-accent grab bndInfo" @click="showTabs") ...
                        span(class="bndInfo") {{ $t('to') }}
                        span(class="fg-accent") {{ bondFields.endDate | formatDate }}
                        span &nbsp;
                    span(v-else-if="bondFields.startDate && bondFields.endDate")
                        span(class="fg-accent grab bndInfo" @click="showTabs") {{ bondFields.startDate | formatDate }}
                        span(class="bndInfo") {{ $t('to') }}
                        span(class="fg-accent") {{ bondFields.endDate | formatDate }}
                        span &nbsp;
                    span(v-if="bondFields.yieldMin && bondFields.yieldMax")
                        span {{ $t('yield') }}
                        span(class="bndInfo") :
                        span(class="fg-accent grab bndInfo" @click="showTabs") {{ bondFields.yieldMin }}
                        span(class="bndInfo") -
                        span(class="fg-accent") {{ bondFields.yieldMax }}%
                        span &nbsp;
                    span(v-else-if="bondFields.yieldMin && !bondFields.yieldMax")
                        span(class="bndInfo") {{ $t('yield') }}:
                        span(class="bndInfo") >
                        span(class="fg-accent") {{ bondFields.yieldMin }}%
                        span &nbsp;
                    span(v-else-if="!bondFields.yieldMin && bondFields.yieldMax")
                        span(class="bndInfo") {{ $t('yield') }}:
                        span(class="bndInfo") <
                        span(class="fg-accent") {{ bondFields.yieldMax }}%
                        span &nbsp;
                    span(v-if="bondFields.couponMin && bondFields.couponMax")
                        span(class="bndInfo") {{ $t('coupon') }}:
                        span(class="fg-accent grab bndInfo" @click="showTabs") {{ bondFields.couponMin }}
                        span(class="bndInfo") -
                        span(class="fg-accent") {{ bondFields.couponMax }}%
                        span &nbsp;
                    span(v-else-if="bondFields.couponMin && !bondFields.couponMax")
                        span(class="bndInfo") {{ $t('coupon') }}:
                        span(class="bndInfo") >
                        span(class="fg-accent") {{ bondFields.couponMin }}%
                        span &nbsp;
                    span(v-else-if="!bondFields.couponMin && bondFields.couponMax")
                        span(class="bndInfo") {{ $t('coupon') }}:
                        span(class="bndInfo") <
                        span(class="fg-accent") {{ bondFields.couponMax }}%
                        span &nbsp;
                    span(v-if="inCP")
                        span(v-if="curTabVal === 'GlobalCorporateBonds' || curTabVal === 'USMuniBonds'")
                            span(v-if="bondFields.moodyLow != '' || bondFields.moodyHigh != ''")
                                span(class="bndInfo") {{ $t('moodys') }}:
                                span(class="fg-accent grab bndInfo" @click="showTabs") {{ bondFields.moodyLow }}
                                span(class="bndInfo") -
                                span(class="fg-accent") {{ bondFields.moodyHigh }}
                                span &nbsp;
                            span(v-if="bondFields.spLow != '' || bondFields.spHigh != ''")
                                span(class="bndInfo") {{ $t('sp') }}:
                                span(class="fg-accent grab bndInfo" @click="showTabs") {{ bondFields.spLow }}
                                span(class="bndInfo") -
                                span(class="fg-accent") {{ bondFields.spHigh }}
                                span &nbsp;
                    span(v-if="!inCP")
                        span(v-if="curTabVal === 'GlobalCorporateBonds' || curTabVal === 'USMuniBonds'")
                            span(class="bndInfo") {{ $t('ratings') }}:
                            span(class="fg-accent") {{ bondFields.rating }}
                            span &nbsp;
                    span(v-if="isNonUS || isUSCorp && bondFields.issuerLabel !== ''")
                        span(class="bndInfo") {{ $t('country_of_issuer') }}:
                        span(class="fg-accent") {{ bondFields.issuerLabel || $t('ALL') }}
                        span &nbsp;
                    span(v-if="curTabVal !== 'USCDs' && curTabVal !== 'USTreasuries'")
                        span(class="bndInfo") {{ $t('currency') }}:
                        span(class="fg-accent") {{ bondFields.currencyLabel }}
                        span &nbsp;
                    span(v-if="curTabVal === 'GlobalCorporateBonds'")
                        span(class="bndInfo") {{ $t('industries') }}:
                        span(class="fg-accent") {{ bondFields.industryLabel }}
                        span &nbsp;
                    span(v-if="isMuni")
                        span(class="bndInfo") {{ $t('states_territories') }}:
                        span(class="fg-accent") {{ bondFields.stateLabel }}
                        span &nbsp;
                    span(v-if="isTreasury")
                        span(class="bndInfo")  {{ $t('treasury_type') }}:
                        span(v-if="bondFields.treasuryType && bondFields.treasuryType != ''" class="fg-accent") {{ bondFields.treasuryType }}
                        span(v-else class="fg-accent") {{ $t('all') }}
                        span &nbsp;
        ScanFilters(
            v-show="!resultsview",
            :showCurrency="showCurrency",
            :showCountry="showCountry",
            :showRatings="showRatings",
            :isMuni="isMuni",
            :isNonUS="isNonUS",
            :isUSCorp="isUSCorp",
            :isTreasury="isTreasury",
            :curTabName="curTabName",
            @findCurrency="saveCurrency",
            @reset="reset",
            @checkCountry="setInstrument",
            @onSubmit="onSubmit",
            ref="scanFilters")

        SearchResults(
            v-if="resultsview",
            :scannerFilters="filters",
            :cusipId="cusipId",
            :cusipVal="cusip",
            :curTabVal="curTabVal",
            :isMuni="isMuni",
            @reset="reset",
            ref="searchResults")
        div(class="inset-16 disclosures")
            p(class="fs8 outsety-4") Source:  Thomsen Reuters Refinitiv
            p(class="fs8") The information presented is taken from, or based upon, information obtained from publicly available sources, the completeness and accuracy of which has not been independently verified, and cannot be assured by Interactive Brokers.
            p(class="fs8") Not all products will be available to all investors due to a number of factors including account type requirements and regional restrictions.
</template>

<script>
    import api from '../api/'
    import { mapState } from 'vuex'
    import ScanFilters from './ScanFilters.vue'
    import SearchResults from './SearchResults.vue'

    export default {
        name: 'BondScanner',

        components: {
            ScanFilters,
            SearchResults,
        },

        props: {
            curTabName: String,
            curTabVal: String,
            cusipId: String,
            cusip: String,
            instrument: String,
            locations: String,
            isMuni: Boolean,
            isNonUS: Boolean,
            isUSCorp: Boolean,
            isTreasury: Boolean,
            showCurrency: Boolean,
            showCountry: Boolean,
            showRatings: Boolean
        },

        created() {
            api.checkCP()
                .then(res => {
                    if (res && res["RESULT"] === true) {
                        this.signedIn = true;
                        this.$emit('signedIn', this.signedIn)
                    }
                })
                .catch(error => console.log(error))
        },

        computed: {
            ...mapState('bondscanner',[
                'urlFilters'
            ])
        },

        data() {
           return {
                bondFields: {},
                resultsview: false,
                issuerCountry: '',
                filters: {
                    instrument: "",
                    locations: "",
                    scanCode: "HIGH_BOND_ASK_YIELD_ALL",
                    secType: "BOND",
                    filters: []
                },
                signedIn: false
            }
        },

        filters: {
            formatDate(val) {
                return val.slice(0, 4) + '/' + val.slice(4, 6) + '/' + val.slice(6);
            }
        },

        methods: {
            onSubmit(filters, bondFields, redirectFromUrl) {
                if (redirectFromUrl) {
                    this.filters.locations = this.urlFilters?.locations;
                    this.filters.instrument = this.urlFilters?.instrument;
                    this.filters.scanCode = this.urlFilters?.scanCode;
                    this.filters.secType = this.urlFilters?.secType;
                    this.filters.filters =  this.urlFilters?.filters
                } else {
                    this.filters.filters = filters;
                    this.filters.instrument = this.instrument;
                    if (this.curTabVal === 'GlobalCorporateBonds' & this.issuerCountry !== 'United States') {
                        for (let i = 0; i < filters.length; i++) {
                            if (filters[i].code === 'currencyLike') {
                                if (filters[i].value === 'EUR' || filters[i].value === 'GBP') {
                                    this.filters.locations = 'BOND.EU.EURONEXT';
                                } else {
                                    this.filters.locations = this.locations;
                                }
                                break;
                            }
                        }
                    } else if (this.curTabVal === 'GlobalCorporateBonds' & this.issuerCountry === 'United States') {
                        this.filters.locations = 'BOND.US';
                    } else {
                        this.filters.locations = this.locations;
                    }
                }
                this.bondFields = bondFields;
                this.resultsview = true;
                this.$emit('hideTabs');
            },

            logOut() {
                api.logOut()
                    .then(() => {
                        window.location.reload();
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log("cookie", document.cookie);
                    })
            },

            prepareScanner(scanner) {
                this.resultsview = true;
                this.filters = scanner.filters;
                scanner.bondFields.cusipId = this.cusipId;
                scanner.bondFields.cusip = this.cusip;
                this.bondFields = scanner.bondFields;
            },

            refresh() {
                this.$refs.searchResults.refresh();
            },

            reset() {
                this.filters.scanCode = 'HIGH_BOND_ASK_YIELD_ALL';
            },

            saveCurrency(currency) {
                this.$emit('checkCurrency', currency);
            },

            setInstrument(issuerCountry) {
                this.issuerCountry = issuerCountry.label;
                if (this.curTabVal === 'GlobalCorporateBonds' && issuerCountry.label === "United States") {
                    this.filters.locations = "BOND.US";
                }
            },

            showTabs() {
                this.resultsview = false;
                this.$nextTick(() => {
                    this.$emit('showTabs', this.cusip, this.cusipId);
                });
            },

            startOver() {
                this.reset();
                this.showTabs();
                this.$emit('startOver');
                this.$refs.scanFilters.resetFilters();
            }
        },

        watch: {
            resultsview: {
                handler: function() {
                    window.scrollTo(0,0);
                }
            }
        },
 }
</script>

<style lang="less" scoped>
.bndInfo {
    margin-right: 4px;
}

.disclosures {
    p {
       max-width: 767px;
    }
}

@media (max-width:450px) {
    div.mobile-desr {
        display: block;
        width: 75vw;
    }
    .bndInfo {
        margin-right: 1px;
    }
}
</style>
